import { createContext, useContext } from 'react'
export type counterType = {
   counterDefault: number
   counter: number
}
type context = {
   counter: number
   counterDefault: number
   setCounter: (value: number) => void
}

const CounterContext = createContext<context>({
   counter: 500,
   counterDefault: 500,
   setCounter: (counter) => counter,
})
export const useCounterContext = () => useContext(CounterContext)
export default CounterContext
